module.exports = __webpack_public_path__ + "img/1F1F9-1F1F7.a3371169.svg";